import { Injectable } from '@angular/core';

import { BiometryKind } from '../model/tokens';

import { BiometricError, BiometricSignIn, EnrollmentState } from './biometric-sign-in';

/**
 * Biometric sign-in on the web build, where there is nowhere safe to keep a password.
 *
 * `WebAuthn` could in principle raise a platform authenticator here, and deliberately is not used: it
 * proves possession of a device rather than releasing a stored secret, so it cannot do what this port
 * exists to do. Storing the password anywhere a browser offers would put a plaintext credential in
 * `localStorage` beside a Durable Root that is already there because a browser has no Keychain. The web
 * build is an internal development convenience; see ADR 0003.
 *
 * `enrollment` answers `notEnrolled`, so nothing offers the button and nothing offers to store
 * anything. `signIn` rejects rather than resolving, because unlike the rest of these it is the one
 * method whose contract is to return credentials — resolving with none would be a lie the caller cannot
 * check. It is unreachable in practice for the same reason.
 */
@Injectable()
export class WebBiometricSignIn implements BiometricSignIn {
  async enrollment(): Promise<EnrollmentState> {
    return 'notEnrolled';
  }

  async canEnroll(): Promise<boolean> {
    return false;
  }

  async biometry(): Promise<BiometryKind> {
    return 'none';
  }

  async signIn(): Promise<{ email: string; password: string }> {
    throw new BiometricError({ kind: 'vaultUnavailable' }, 'biometric sign-in is not available on the web');
  }

  async saveCredentials(): Promise<void> {
    return;
  }

  async hasCredentials(): Promise<boolean> {
    return false;
  }

  async enroll(): Promise<void> {
    return;
  }

  async disable(): Promise<void> {
    return;
  }

  async decline(): Promise<void> {
    return;
  }
}
